"use strict";
exports.__esModule = true;
var transformValue_1 = require("./transformValue");
function getSimpleValue(_a, config) {
    var $ = _a.$, el = _a.el;
    var html = config.html, attr = config.attr, initial = config.initial, fill = config.fill;
    var element = $(el);
    if (fill) {
        return fill;
    }
    var value;
    if (html) {
        value = element.html();
    }
    else if (attr) {
        value = element.attr(attr);
    }
    else {
        value = element.text();
    }
    if (initial && !value) {
        value = initial;
    }
    return transformValue_1["default"](value, config);
}
exports["default"] = getSimpleValue;
